import { render, staticRenderFns } from "./PerformanceIndicatorsSection.vue?vue&type=template&id=1b5b1c23"
import script from "./PerformanceIndicatorsSection.vue?vue&type=script&lang=js"
export * from "./PerformanceIndicatorsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports